import React, { useState, useEffect } from "react";
import { Row, Col, Card, Form, Container } from "react-bootstrap";
import swal from "sweetalert";
import { Link, useNavigate } from "react-router-dom";
import { FaPeopleGroup } from "react-icons/fa6";
import signup from "../../../assets/images/team/refer.png";
import apply from "../../../assets/images/Home/reward.png";
import Join from "../../../assets/images/Home/profile.png";
import arrow from "../../../assets/images/Home/arrowup.png";

function Refer() {
  const user_id = localStorage.getItem("user_id");
  const [profile, setProfile] = useState({});

  useEffect(() => {
    fetchProfile();
  }, []);

  const fetchProfile = async () => {
    const token = localStorage.getItem("token");
    try {
      const res = await fetch(`${process.env.REACT_APP_BASE_URL}/profile`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ id: user_id }),
      });

      if (!res.ok) throw new Error("Failed to fetch profile");

      const data = await res.json();
      setProfile(data.data);
    } catch (err) {
      console.error("Failed to fetch profile", err);
    }
  };

  const referralLink = `${window.location.origin}/?ref=${profile.reffer_id}`;

  const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: "Join me on this app!",
          text: `Use my referral link to sign up:`,
          url: referralLink,
        });
      } catch (err) {
        console.error("Failed to share", err);
      }
    } else {
      navigator.clipboard.writeText(referralLink);
    }
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(referralLink);
    swal({
      title: "Copied!",
      text: "Referral link copied to clipboard",
      icon: "success",
      timer: 20000,
    });
  };

  return (
    <Card className="dashboard_Refer shadow border-0">
      <Card.Header className="bg-primary text-white fw-semibold">
        <FaPeopleGroup className="me-2" />
        Refer & Earn
      </Card.Header>
      <Row className="d-flex justify-content-center my-4">
        <Col md={7}>
          <Card>
            <Card.Header className="bg_light">
              Hello, {profile.username || "User"}! Share your referral link
              below:
            </Card.Header>
            <Card.Body>
              <Form.Control
                type="text"
                value={referralLink}
                readOnly
                className="mb-3 text-center"
              />

              <div className="d-flex justify-content-center align-items-center gap-2">
                <button className="educate-btn btn_3 " onClick={handleCopy}>
                  Copy Link
                </button>
                <button className="educate-btn" onClick={handleShare}>
                  <span className="educate-btn__curve" />
                  Share
                </button>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <div className="referral-form-section mb-5">
        <Container>
          <div className="steps-container">
            <div className="sec-title">
              <h3 className="title mb-4">3 Easy Step to Earn Rewards</h3>
            </div>
            <div className="steps">
              {/* Step 1 */}
              <Link to={"/dashboard"} className="step step1">
                <div className="icon">
                  <img src={signup} alt="signup" />
                </div>
                <p>Refer</p>
              </Link>

              <div className="arrow">
                <img src={arrow} alt="arrow" />
              </div>

              {/* Step 2 */}
              <Link to={"/dashboard"} className="step step2">
                <div className="icon">
                  <img src={Join} alt="Complete Profile" />
                </div>
                <p>Join Friend</p>
              </Link>

              <div className="arrow arrowDown">
                <img src={arrow} alt="arrow" />
              </div>

              {/* Step 3 */}
              <Link to={"/dashboard"} className="step step3">
                <div className="icon">
                  <img src={apply} alt="Apply" />
                </div>
                <p>Earn Reward</p>
              </Link>
            </div>
          </div>
        </Container>
      </div>
    </Card>
  );
}

export default Refer;
